import { useId } from "react";

import {
  CC_CENTER_SECTION_INPUT_MAX_LENGTH,
  FULL_WIDTH_INPUT_MAX_LENGTH,
} from "@/components/AIComponents/ExportablesModal/templates/components/OrganizerDirections/OrganizerDirections.constants";
import { TemplateTextArea } from "@/components/AIComponents/ExportablesModal/templates/components/TemplateTextArea";
import {
  vennDiagramTextAreaCss,
  vennDiagramTextAreaWithCounterCss,
} from "./CompareContrastOrganizer.styles";

interface OrganizerCircleTextAreaProps {
  section: "left" | "right" | "center";
  value: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

const OrganizerCircleTextArea = ({
  section,
  value,
  onChange,
}: OrganizerCircleTextAreaProps) => {
  const id = useId();
  const maxLength =
    section === "center"
      ? CC_CENTER_SECTION_INPUT_MAX_LENGTH
      : FULL_WIDTH_INPUT_MAX_LENGTH;
  const formattedValue = value.substring(0, maxLength);
  const formattedSection = section.charAt(0).toUpperCase() + section.slice(1);
  const ariaLabel = ` ${formattedSection} circle input`;

  return (
    <TemplateTextArea
      value={formattedValue}
      maxLength={maxLength}
      css={vennDiagramTextAreaWithCounterCss(section)}
    >
      <TemplateTextArea.TextArea
        id={id}
        data-qa-selector={id}
        onChange={onChange}
        aria-label={ariaLabel}
        css={vennDiagramTextAreaCss}
      />
      <TemplateTextArea.CharacterCount />
    </TemplateTextArea>
  );
};

export default OrganizerCircleTextArea;
